import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import { AgeAndGenderComponent } from './components/age-and-gender/age-and-gender.component';
import { ConsumerSpendingComponent } from './components/consumer-spending/consumer-spending.component';
import { ConsumerDemandComponent } from './components/consumer-demand/consumer-demand.component';
import { CustomRegionComponent } from './components/custom/custom-region/custom-region.component';
import { DashboardDialogBoxComponent } from './components/custom/dashboard-dialog-box/dashboard-dialog-box.component';
import { DeleteRegionComponent } from './components/custom/delete-region/delete-region.component';
import { DialogBoxComponent } from './components/custom/dialog-box/dialog-box.component';
import { AgeGroupSelectorComponent } from './components/dropdown/age-group-selector/age-group-selector.component';
import { CountryAndRegionSelectorComponent } from './components/dropdown/country-and-region-selector/country-and-region-selector.component';
import { DashboardSelectorComponent } from './components/dropdown/dashboard-selector/dashboard-selector.component';
import { SpendingGroupSelectorComponent } from './components/dropdown/spending-group-selector/spending-group-selector.component';
import { ExportDataComponent } from './components/export-data/export-data.component';
import { HeaderComponent } from './components/header/header.component';
import { MainComponent } from './components/main/main.component';
import { ExportDataMapComponent } from './components/map/export-data-map/export-data-map.component';
import { MapHeaderComponent } from './components/map/map-header/map-header.component';
import { MapTitleDropdownComponent } from './components/map/map-title-dropdown/map-title-dropdown.component';
import { MapComponent } from './components/map/map.component';
import { PanelDropdownComponent } from './components/panel-dropdown/panel-dropdown.component';
import { RegionComparisonChartComponent } from './components/region-comparison-chart/region-comparison-chart.component';
import { RegionComparisonProjectionComponent } from './components/region-comparison-chart/region-comparison-projection/region-comparison-projections.component';
import { RegionComparisonTableComponent } from './components/region-comparison-table/region-comparison-table.component';
import { RegionComparisonComponent } from './components/region-comparison/region-comparison.component';
import { SpendingDistribBreakdownTableComponent } from './components/spending-distrib-breakdown-table/spending-distrib-breakdown-table.component';
import { SpendingDistributionComponent } from './components/spending-distribution/spending-distribution.component';
import { TagsComponent } from './components/tags/tags.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { UpsaleModalComponent } from './components/upsale-modal/upsale-modal.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { FreemiumRegisterComponent } from './components/freemium-register/freemium-register.component';
import { InfoTooltip } from './components/info-tooltip/info-tooltip.component';
import { NestedDropdown } from './components/dropdown/nested-dropdown/nested-dropdown.component';
import { SizeOfThePrize } from './components/size-of-the-prize/size-of-the-prize.component';
import { TreeMap } from './components/treemap/treemap.component';
import { Piechart } from './components/piechart/piechart.component';
import { Scatter } from './components/scatter/scatter.component';
import { SizeOfThePrizeChart } from './components/size-of-the-prize-chart/size-of-the-prize-chart.component';
import { ConsumerRanking } from './components/consumer-ranking/consumer-ranking.component';
import { TopConsumer } from './components/top-consumer/top-consumer.component';
import { MainTabs } from './components/main-tabs/main-tabs.component';
import { ConsumerSpendingSizePrizeComponent } from './components/consumer-spending-size-prize/consumer-spending-size-prize';
import { ZoomControls } from './components/zoom-controls/zoom-controls..component';
import { MapHeaderCategoriesComponent } from './components/map/map-header-categories/map-header-categories.component';
import { CategoriesSwitchComponent } from './components/categories-switch/categories-switch.component';
import { SharedAnimationModule } from '../shared-animation.module';
import { FreemiumPayWallComponent } from './components/freemium-pay-wall/freemium-pay-wall.component';
import { SpendingIncomeSelectorComponent } from './components/dropdown/spending-income-selector/spending-income-selector.component';
import { SpendingGroupContainerComponent } from './components/dropdown/spending-group-container/spending-group-container.component';
import { FreemiumHeaderComponent } from './components/freemium-header/freemium-header.component';
import { LeagcyHeaderComponent } from './components/legacy-header/legacy-header.component';
import { FreemiumIntroductionComponent } from './components/freemium-introduction/freemium-introduction.component';
import { MobileUnavailableComponent } from './components/mobile-unavailable/mobile-unavailable.component';
import { CategoriesConsumerComponent } from './components/categories-consumer-message/categories-consumer-message.component';
import { AgeGenerationsSelectorComponent } from './components/dropdown/age-generations-selector/age-generations-selector.component';

@NgModule({
  imports: [
    HttpClientModule,
    BrowserModule,
    RouterModule,
    SharedModule,
    SharedAnimationModule,
  ],
  declarations: [
    MainComponent,
    SizeOfThePrize,
    ZoomControls,
    ConsumerSpendingSizePrizeComponent,
    MainTabs,
    SizeOfThePrizeChart,
    ConsumerRanking,
    TopConsumer,
    TreeMap,
    Piechart,
    Scatter,
    ConsumerSpendingComponent,
    InfoTooltip,
    ConsumerDemandComponent,
    NestedDropdown,
    RegionComparisonTableComponent,
    SpendingDistribBreakdownTableComponent,
    AgeGroupSelectorComponent,
    SpendingIncomeSelectorComponent,
    AgeGenerationsSelectorComponent,
    SpendingGroupSelectorComponent,
    SpendingGroupContainerComponent,
    CountryAndRegionSelectorComponent,
    DashboardSelectorComponent,
    HeaderComponent,
    FreemiumHeaderComponent,
    LeagcyHeaderComponent,
    MapComponent,
    MapHeaderCategoriesComponent,
    FreemiumRegisterComponent,
    ExportDataComponent,
    AgeAndGenderComponent,
    SpendingDistributionComponent,
    TagsComponent,
    CustomRegionComponent,
    DeleteRegionComponent,
    DialogBoxComponent,
    DashboardDialogBoxComponent,
    TopBarComponent,
    CategoriesSwitchComponent,
    RegionComparisonComponent,
    RegionComparisonChartComponent,
    RegionComparisonProjectionComponent,
    MapTitleDropdownComponent,
    MapHeaderComponent,
    ExportDataMapComponent,
    PanelDropdownComponent,
    UpsaleModalComponent,
    ErrorModalComponent,
    FreemiumPayWallComponent,
    FreemiumIntroductionComponent,
    CategoriesConsumerComponent,
    MobileUnavailableComponent,
  ],
  exports: [
    // TODO remove exports
    RegionComparisonTableComponent,
    SpendingDistribBreakdownTableComponent,
    AgeGroupSelectorComponent,
    SpendingIncomeSelectorComponent,
    AgeGenerationsSelectorComponent,
    SpendingGroupSelectorComponent,
    CountryAndRegionSelectorComponent,
    DashboardSelectorComponent,
    ErrorModalComponent,
  ],
})
export class MainAppModule {}
